// extracted by mini-css-extract-plugin
export default {"container":"styles_container__560MJ","height":"styles_height__RFpsL","buttonSubmit":"styles_buttonSubmit__vFxCr","loadingIcon":"styles_loadingIcon__hHBSd"};